import request from "@/utils/request";
import { jsonHeaders } from "./api-header-conf.js";

export function queryLeaseInfo(wxId) {
  return request({
    jsonHeaders,
    url: `/lease/wxId/${wxId}`,
    method: "GET"
  });
}
